import clsx from 'clsx';
import React from 'react';

import { User } from '@utils/backend-api/currentUser';

import { userName } from '../userHelpers';
import styles from './styles.module.scss';

export enum AvatarSizes {
  Small = 30,
  Medium = 40,
  Large = 50,
}

export default function UserAvatar({
  user,
  size,
  grow = false, // grow dynamically increases to large when rendered on large viewports
  customStyles,
}: {
  user: Pick<User, 'picture_url' | 'name' | 'username'>;
  size: AvatarSizes;
  customStyles?: string;
  grow?: boolean;
}) {
  const name = userName(user);

  return (
    <div className={clsx(styles.avatarContainer)}>
      <picture>
        {user.picture_url ? (
          <>
            <source srcSet={`${user.picture_url}&fm=webp`} type="image/webp" />
            <source srcSet={`${user.picture_url}&fm=jpg`} type="image/jpeg" />
            <img
              src={user.picture_url}
              alt={name}
              className={clsx(styles.avatar, styles[size], { [styles.grow]: grow }, customStyles)}
              height={size}
              width={size}
            />
          </>
        ) : (
          <div className={clsx(styles.avatarPlaceholder)}>{name ? name[0].toUpperCase() : ''}</div>
        )}
      </picture>
    </div>
  );
}
